import React, { Component } from "react";
import bgimg from "../../assets/image/second.jpg";
import Footer from '../Public/Footer'
import { Parallax, Background } from 'react-parallax';
import {Typography } from '@material-ui/core'
//import logo from '../../assets/image/logo.png'

const insideStyles = {
	  width: "80%",
  	textAlign: 'center',
		background: "rgba(255,255,255, .49)",
		padding: 20,
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%,-50%)"
  };

class HomePage extends Component {
	

  render() {

    return (
		<div className="home-page">
			<Background>
				<Parallax
					bgImage={bgimg}
					bgImageAlt="the dog"
					strength={-200}
				>
					<div style={insideStyles}> 
							<Typography component="h2" variant="display3">
								Personal Trainer Web Software
							</Typography>
					</div>
					<div style={{ height: '550px' }} />
				</Parallax>
             </Background>
		     <Footer />
		</div>
    );
  }
}

export default HomePage;